import { render } from "./JestIcon.vue?vue&type=template&id=31c630fc&scoped=true"
import script from "./JestIcon.vue?vue&type=script&lang=js"
export * from "./JestIcon.vue?vue&type=script&lang=js"

import "./JestIcon.vue?vue&type=style&index=0&id=31c630fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c630fc"]])

export default __exports__